import { Component } from '@cms-max/medicare-api-sdk'
import { Card as SettingCard } from 'components/Card/Card'
import { CardStack, CardStackItem } from 'components/CardStack/CardStack'
import { useTranslation } from 'react-i18next'

type EasyPayNotEnrolledCardProps = {
  disableEdit?: boolean
}
export function EasyPayNotEnrolledCard ({ disableEdit }: EasyPayNotEnrolledCardProps) {
  const { t } = useTranslation('easyPaySummary')

  return (
    <CardStack>
      <CardStackItem>
        <SettingCard
          title={t('easyPayStatus.enrollmentStatus')}
          buttonText={t('easyPayStatus.buttons.start')}
          buttonCallbackOrHref={`/premiums/easy-pay/signup`}
          displayValue={t('easyPayStatus.statuses.notEnrolled')}
          disableEdit={disableEdit}
          buttonSiteActivityProps={{
            core: {
              component: Component.EasyPay,
              elementId: 'premiums_easypaylanding_easypayenroll_click',
              coreClickData: {
                linkText: t('easyPayStatus.buttons.start'),
                linkUrl: '/premiums/easy-pay/signup'
              }
            }
          }}
          headingLevel='3'
        />
      </CardStackItem>
      <CardStackItem className="ds-u-padding--3">
        {t('easyPayStatus.notEnrolledDescription')}
      </CardStackItem>
    </CardStack>
  )
}
